import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const getApplicantActions = (applicantId) =>
    axios.get(`${apiUrl}ats/applicant-actions/by-applicant/${applicantId}`);

export const getApplicantActionById = (id) =>
    axios.get(`${apiUrl}ats/applicant-actions/${id}`);

export const createApplicantAction = (data) =>
    axios.post(`${apiUrl}ats/applicant-actions`, data);
